import { classNames } from '@utils/classNames';
import { ParameterDto } from '@src/types/types';
import { ParameterListItem } from './ParameterListItem';

export type ParameterListItemsProps = {
  items: ParameterDto[];
  className?: string;
};

export const ParameterListItems = ({
  items,
  className,
}: ParameterListItemsProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col gap-2.5 md:gap-5 print:gap-5',
        className,
      )}
      data-testid="parameter-list-items"
    >
      {items
        .filter((item) => item.regulations.length > 0)
        .map((item, index) => (
          <ParameterListItem key={index} parameter={item} />
        ))}
    </div>
  );
};
